import { render, staticRenderFns } from "./NoMealsOpen.vue?vue&type=template&id=315c292b&scoped=true&"
import script from "./NoMealsOpen.vue?vue&type=script&lang=js&"
export * from "./NoMealsOpen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315c292b",
  null
  
)

export default component.exports